module.exports = __webpack_public_path__ + "static/kitchen-e68955166aaff751348f638ba7e66354.jpg";